import { Injectable } from '@angular/core';
import { Router, Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { DetalhamentoService } from './detalhamento/detalhamento.service';

@Injectable()
export class DetalhamentoProdutoResolver implements Resolve<any> {

  constructor(private detalhamentoService: DetalhamentoService, private router: Router) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {

    return this.detalhamentoService.getDetalhamento(route.params.id).pipe(
      map(res => {
        if(res === null){
          this.router.navigate(['/page-not-found']);
          return of(null);
        }
        return res;
      }),
      catchError(err => {
        this.router.navigate(['/page-not-found']);
        return of(null);
      })
    );

  }

}
